<template>
  <spinner v-if="cargando"/>
  <div v-else :class="!mostrar ? 'contenedor' : ''">
    <imagen360 :cargando="false" v-if="color"/>
    <div v-else class="pt-5">
      <img
          class="img-fluid animated fadeInLeftBig"
          :alt="version.dt1"
          :src="imgColor ? imgColor : sin"
      />
    </div>

    <!--        <p class="centrado" v-if="tiene360">{{tiene360}}</p>-->
    <button class="btn-sobre btn btn-light btn-elevate btn-pill btn-sm" v-if="activo360 && !mostrar" type="button"
            v-on:click="mostrar=true">
      <i class="flaticon2-circular-arrow"></i> 360
    </button>
  </div>
</template>

<script>
import spinner from "./spinner-imagen";
import imagen360 from "./imagen-360";

export default {
  name: "imagen-vehiculo",
  data: () => ({
    imagen: null,
    logo: null,

    modelo: {},
    version: {},
    clase: 'logo-version',
    mostrar: true,
    sin: require("../../../assets/images/sin_auto.png")
  }),
  props: ["cargando", "activo360", "activar"],
  components: {
    spinner,
    imagen360,
  },
  watch: {
    version: function (valor) {
      if (valor.elements)
        this.imagen = process.env.VUE_APP_URL_API + this.version.elements[0].dt2;
      else
        this.imagen = this.sin;
    },
    cargando: function (valor) {
      if (!valor)
        this.version = this.$store.getters.getPasos["2"].version;

    },
    activar: function (valor) {
      if (this.$store.getters.getPasos["2"].color.id && this.$store.getters.getPasos["2"].color.elements)
        this.mostrar = valor;
    }
  },
  computed: {
    imgColor: function () {
      if (this.$store.getters.getPasos["2"].color.dt4) {
        return process.env.VUE_APP_URL_API + this.$store.getters.getPasos["2"].color.dt4;
      } else {
        return this.imagen;
      }
    },
    color: function () {
      if (this.$store.getters.getPasos["2"].color.id && this.$store.getters.getPasos["2"].color.elements)
        return this.activar;
      else
        return false;
    },
    tiene360: function () {
      if (this.activar && this.$store.getters.getPasos["2"].color.elements === null)
        return "No hay un 360 registrado para este color";
      else
        return false;
    }
  },
  methods: {},
  created() {
    this.version = this.$store.getters.getPasos["2"] ? this.$store.getters.getPasos["2"].version : {};
  },
}
</script>

<style scoped>
.img-fluid {
  min-width: 100%;
}

.btn-sobre {
  position: absolute;
  bottom: 10px;
  left: 10px;
}
</style>
